import React from "react";
import { Workflow, BCMSDate, BCMSRecord, useBCMSContext, useParams, useModel } from "@bcm-dev/bcms-vite";
import { Transaction } from "model";
import CardOnFilePage from "components/pages/CardOnFilePage";
import CardOnFilePageV2 from "components/pages/CardOnFilePageV2";
import MerchantDetailsPage from "components/pages/MerchantDetailsPage";
import UpdateCardOnFilePage from "components/pages/UpdateCardOnFilePage";
import SecurityTokenReceiveTokenPage from "components/pages/SecurityTokenReceiveTokenPage";
import EnterSecurityTokenPage from "components/pages/EnterSecurityTokenPage";
import VerificationEnterCredsPage from "components/pages/VerificationEnterCredsPage";
import VerificationSecurityCodePage from "components/pages/VerificationSecurityCodePage";
import VerificationSuccessPage from "components/pages/VerificationSuccessPage";

const steps = [
    CardOnFilePageV2,
    MerchantDetailsPage,
    UpdateCardOnFilePage,
    SecurityTokenReceiveTokenPage,
    EnterSecurityTokenPage,
    VerificationEnterCredsPage,
    VerificationSecurityCodePage,
    VerificationSuccessPage
];
//workflowStep.workflow.goStep(2,{transfer:transfer.setDefaults()})  
/**
 * @function CardOnFileWorkflow
 * @returns {React.Component}
 * @description The main component for the dispute transaction workflow.
 * @exported true
 * @example <CardOnFileWorkflow />
 */
export default function CardOnFileWorkflow(props) {
    const globalController = useBCMSContext();
    const transactionID = useParams().transactionID ?? "0";
    const value = getDefault(globalController, transactionID);
    return <Workflow value={ value } steps={ steps } />;
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @returns {OBJECT}
 * @exported true
 * @description Returns the default values for the dispute transaction
 */
export const getDefault = (controller, transactionID) => {
    BCMSRecord.globalControllerFor([ Transaction ], controller);
    const transaction = Transaction.initByID(transactionID);

    return {
        transaction: transaction,
        didUserMakeThisTransaction: undefined,
        disputeReason: "",
        disputeReasonAdditionalComments: "",
        confirmationNumber: "42101123000",
        disputeSubmissionDate: BCMSDate.init()
    }
};